import React from 'react'

const Manual_admin_descuentos = () => {
  return (
    <>
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
        <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
        Admin - Descuentos
        </h2>
        <p className="text-lg text-gray-700 mb-6">
        La guía explica cómo configurar descuentos paso a paso, permitiendo personalizar tipos y valores
        según las necesidades del negocio. Su uso optimiza las ventas, mejora la satisfacción del cliente y maximiza
        las capacidades del sistema.
        </p>
        <iframe
        src="https://scribehow.com/embed/Admin__Descuentos__dyb2okLoRgCupWxHyGBYCA?as=scrollable"
        className="scribe-iframe-general-25"
        width="100%"
        height="5250"
        allowFullScreen
        style={{ border: 0, minHeight: '640px' }}
        ></iframe>
        </div>
    </div>
    </>
  )
}

export default Manual_admin_descuentos